import '../views/statements/statements.html';

export class StatementsRouterStates {
    /** @ngInject */
    constructor($stateProvider) {
        this.$stateProvider = $stateProvider;
    }

    defineStates() {
        this.$stateProvider.state('app.statements', {
            url: '/statements',
            templateUrl: './app/views/statements/statements.html',
            controller: 'CommonViewController',
            controllerAs: 'vm',
            params: {
                pageTitle: 'REPORTINGS',
            }
        });
    }
}
